export default __webpack_public_path__ + "static/contact-37dad679b7333918e5965cec1b55cf80.png";